import { z } from 'zod';
import { JsonValueSchema } from '../../common.schemas';
import {
    CardPointeLoggingRedactionOutcome,
    type CardPointeLoggingRedactionNormalizedResult,
    type CardPointeLoggingRedactionRequestDetails,
    type CardPointeLoggingRedactionResponseDetails,
} from '../../../types/ipg/cardpointe/cardpointe-logging-redaction.types';

export const CardPointeLoggingRedactionRequestDetailsSchema: z.ZodType<CardPointeLoggingRedactionRequestDetails> =
    z
        .object({
            payload: JsonValueSchema,
        })
        .strict();

export const CardPointeLoggingRedactionNormalizedResultSchema: z.ZodType<CardPointeLoggingRedactionNormalizedResult> =
    z
        .object({
            redacted_payload: JsonValueSchema,
            omitted_sensitive_key_count: z.number().int().nonnegative(),
        })
        .strict();

export const CardPointeLoggingRedactionRedactedResponseDetailsSchema: z.ZodObject<{
    outcome: z.ZodLiteral<typeof CardPointeLoggingRedactionOutcome.REDACTED>;
    normalized_result: typeof CardPointeLoggingRedactionNormalizedResultSchema;
}> = z
    .object({
        outcome: z.literal(CardPointeLoggingRedactionOutcome.REDACTED),
        normalized_result: CardPointeLoggingRedactionNormalizedResultSchema,
    })
    .strict() satisfies z.ZodType<
    Extract<
        CardPointeLoggingRedactionResponseDetails,
        {
            readonly outcome: typeof CardPointeLoggingRedactionOutcome.REDACTED;
        }
    >
>;

export const CardPointeLoggingRedactionMalformedInputResponseDetailsSchema: z.ZodObject<{
    outcome: z.ZodLiteral<typeof CardPointeLoggingRedactionOutcome.MALFORMED_INPUT>;
    message: z.ZodString;
    payload: z.ZodOptional<z.ZodUnknown>;
}> = z
    .object({
        outcome: z.literal(CardPointeLoggingRedactionOutcome.MALFORMED_INPUT),
        message: z.string().min(1),
        payload: z.unknown().optional(),
    })
    .strict() satisfies z.ZodType<
    Extract<
        CardPointeLoggingRedactionResponseDetails,
        {
            readonly outcome: typeof CardPointeLoggingRedactionOutcome.MALFORMED_INPUT;
        }
    >
>;

export const CardPointeLoggingRedactionResponseDetailsSchema: z.ZodType<CardPointeLoggingRedactionResponseDetails> =
    z.discriminatedUnion('outcome', [
        CardPointeLoggingRedactionRedactedResponseDetailsSchema,
        CardPointeLoggingRedactionMalformedInputResponseDetailsSchema,
    ]);
